<main class="app_template_g__container" id="templateContainer">
	<app-print-header></app-print-header>
	<p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
		<ng-template pTemplate="header">
			<label><strong>Esops de exposición: </strong>
				{{ examen.esops?.length }}</label>
		</ng-template>
		<p-scrollPanel [style]="{ height: '200px' }">
			<p-table [value]="examen.esops">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 20%; text-align: center;">Código</th>
						<th style="width: 80%; text-align: center;">Concepto</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td style="text-align: center;">{{ item.codigo }}</td>
						<td style="text-align: center;">{{ item.descripcion }}</td>
					</tr>
				</ng-template>
			</p-table>
		</p-scrollPanel>
		<p-footer>
			<p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
		</p-footer>
	</p-dialog>
	<!-- ------------------------------------------------inicio de formulario------------------------------------------------ -->

	<form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
		<div class="form-container p-fluid">

			<!-- ------------------------------------------------encabezado------------------------------------------------ -->
			<div class="p-grid p-jc-between" style="margin-bottom: 15px;">
				<div class="" style="display: flex;">
					<span>
						<i (click)="goBack()" class="pi pi-arrow-left"
							style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
					</span>
					<label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
				</div>

				<span class="print_hide-on-print">
					<app-print-button></app-print-button>
				</span>
			</div>
			<!-- ------------------------------------------------primer row (fecha)------------------------------------------------ -->
			<div class="p-grid">
				<div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
					<app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
					<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						{{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
					</span>

					<p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date"
						dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init"
						[maxDate]="maxDate" [minDate]="minDate" class="print_hide-on-print"
						[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
						[disabled]="examen?.modoVista === 'ver'">
					</p-calendar>

					<app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid">
					</app-invalid-from-message>
				</div>

				<!-- NRO LOTE-->
				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Lote"></app-fiel-title>
					<p class="readOnly">
						{{examen.lote.numeroLote}}
					</p>
				</div>

				<!-- NRO CARPETA-->
				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Carpeta"></app-fiel-title>
					<p class="readOnly">
						{{examen.numeroCarpeta}}
					</p>
				</div>

				<div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
					<label class="color-text" (click)="displayAgentes = true">
						Esops de exposición ({{ examen.esops?.length }})</label>
				</div>
			</div>

			<!-- Seccion Empleador -->
			<div *ngIf="configForm.findSection('Empleador')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Empleador") }}. Datos de la empresa
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid">
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Razón Social"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIT"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Establecimiento"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Teléfono"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Dirección de E-mail"></app-fiel-title>
						<p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
					</div>
				</div>
			</div>

			<!-- Seccion Trabajador -->
			<div *ngIf="configForm.findSection('Trabajador')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Trabajador") }}. Datos Del Trabajador
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
						  formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
						  [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.apellidoNombre.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
											message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
										</app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIL"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.cuil}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
						  placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
						  [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
						  (onSelect)="calculateAge()" (onBlur)="calculateAge()"
						  [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="DNI"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.numeroDocumento}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Sexo"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.sexo}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full p_hidden">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">
							{{ examen.trabajador.calle }} {{ examen.trabajador.numeroCalle }}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Edad"></app-fiel-title>
						<p class="readOnly">
							{{ examen.trabajador.edad }} años
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}"
							alfanumericoDirective formControlName="puestoTrabajador" id="puesto" name="puesto"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.puestoTrabajador.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso"
							class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
							[disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
							[minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
							(onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>

			<!-- ---------------------------------- 3. Estudio ---------------------------------- -->
			<div *ngIf="configForm.findSection('Estudio')">
				<div class="print_dont_break">
					<div class="p-grid p-mt-2">
						<span class="p-title-seccion">
							{{ configForm.findNumberSection("Estudio") }}. Estudio
						</span>
					</div>
					<p-divider></p-divider>
					<!-- ---------------------------------- Tarea habitual del trabajador ---------------------------------- -->
					<div class="p-col-12 p-md-12">
						<div class="p-grid">
							<div class="p-col-12 p-md-12">
								<app-fiel-title label="Tarea habitual del trabajador: " required="true">
								</app-fiel-title>
							</div>
							<div *ngIf="configForm.findField('tareaHabitual')" class="p-col-12 p-md-6 print_row-full">
								<p [ngClass]="{'print_show-on-print': f.tareaHabitual.value.length > 0,
                              		'print_hide-on-print': f.tareaHabitual.value.length < 1}"
									class="print_hidden-area-before-print print_row-full p-field-word-break">
									{{f.tareaHabitual.value}}
								</p>
								<textarea class="print_hide-on-print"
									[ngClass]="{'ng-invalid ng-dirty': submitted && f.tareaHabitual.invalid}" cols="30"
									formControlName="tareaHabitual" id="result" maxlength="1000" name="resul"
									pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
                				</textarea>
								<small style="text-align: end;">
									{{ f.tareaHabitual.value.length }}/1000
								</small>
								<app-invalid-from-message *ngIf="submitted && f.tareaHabitual.errors?.required">
								</app-invalid-from-message>
								<app-invalid-from-message *ngIf="f.tareaHabitual.errors?.maxlength"
									message="Solo se permiten {{ f.tareaHabitual.errors.maxlength.requiredLength  }} caracteres">
								</app-invalid-from-message>
							</div>
						</div>
					</div>
				</div>
				<!-- ---------------------------------- Antecedentes laborales en la misma actividad  ---------------------------------- -->
				<div class="p-col-12 p-md-12">
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-12 title">
							<app-fiel-title label="Antecedentes laborales en la misma actividad: " required="true">
							</app-fiel-title>
						</div>
						<div style="display: flex; flex-direction: row;">
							<div class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-radioButton [value]="true" formControlName="antecedentesLaboralesActividad"
										label="Si" name="antecedentesLaboralesActividad"
										[disabled]="examen?.modoVista === 'ver'"
										[ngModel]="examen.antecedentesLaboralesActividad"
										(onClick)="clickRadioButtonAntecedentesLaboralesActividad()">
									</p-radioButton>
								</div>
							</div>
							<div class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-radioButton [value]="false" formControlName="antecedentesLaboralesActividad"
										label="No" name="antecedentesLaboralesActividad"
										[disabled]="examen?.modoVista === 'ver'"
										[ngModel]="examen.antecedentesLaboralesActividad"
										(onClick)="clickRadioButtonAntecedentesLaboralesActividad()">
									</p-radioButton>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message *ngIf="submitted && f.antecedentesLaboralesActividad.invalid">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describa: " [required]="f.antecedentesLaboralesActividad.value">
							</app-fiel-title>
						</div>
						<div class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.antecedentesLaboralesDescripcion.value.length > 0,
                				'print_hide-on-print': f.antecedentesLaboralesDescripcion.value.length < 1}"
								class="print_hidden-area-before-print print_row-full p-field-word-break">
								{{f.antecedentesLaboralesDescripcion.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesLaboralesDescripcion.invalid}"
								cols="30" formControlName="antecedentesLaboralesDescripcion" id="result"
								maxlength="1000" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              				</textarea>
							<small style="text-align: end;">
								{{ f.antecedentesLaboralesDescripcion.value.length }}/1000
							</small>
							<app-invalid-from-message
								*ngIf="submitted && f.antecedentesLaboralesDescripcion.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.antecedentesLaboralesDescripcion.errors?.maxlength"
								message="Solo se permiten {{ f.antecedentesLaboralesDescripcion.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<!-- ---------------------------------- 4. Tiempo de tarea ---------------------------------- -->
			<div *ngIf="configForm.findSection('TiempoDeTarea')">
				<div class="print_dont_break">
					<div class="p-grid p-mt-2">
						<span class="p-title-seccion">
							{{ configForm.findNumberSection("TiempoDeTarea") }}. Tiempo de Tarea
						</span>
					</div>
					<p-divider></p-divider>
					<div class="p-col-12 p-md-12">
						<div class="p-grid">
							<div class="p-field p-col-12 p-md-4">
								<app-fiel-title label="Nro.Horas/Días en el trabajo: " required="true"></app-fiel-title>
								<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.tiempoTareaDiaria.invalid}"
									numberDirective formControlName="tiempoTareaDiaria" id="puesto" name="puesto"
									maxlength="4" pInputText type="text"
									[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
								<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
									{{examForm.controls.tiempoTareaDiaria.value}}
								</span>
								<app-invalid-from-message *ngIf="submitted && f.tiempoTareaDiaria.invalid">
								</app-invalid-from-message>
							</div>
							<div class="p-field p-col-12 p-md-4">
								<app-fiel-title label="Nro.Horas/Semanas en el trabajo: " required="true">
								</app-fiel-title>
								<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.tiempoTareaSemanal.invalid}"
									numberDirective formControlName="tiempoTareaSemanal" id="puesto" name="puesto"
									maxlength="4" pInputText type="text"
									[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
								<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
									{{examForm.controls.tiempoTareaSemanal.value}}
								</span>
								<app-invalid-from-message *ngIf="submitted && f.tiempoTareaSemanal.invalid">
								</app-invalid-from-message>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ---------------------------------- 5. Manipulación Manual de Cargas ---------------------------------- -->
			<div *ngIf="configForm.findSection('ManipulacionManualDeCargas')">
				<div class="print_dont_break">
					<div class="p-grid p-mt-2">
						<span class="p-title-seccion">
							{{ configForm.findNumberSection("ManipulacionManualDeCargas") }}. Manipulación Manual de
							Cargas
						</span>
					</div>
					<p-divider></p-divider>
					<div class="p-field-without-border p-col-12 p-md-12 print_row-full print_row-fill-block">
						<div class="p-grid print_row-content-inline">
							<div *ngFor="let item of manipulacionCargaValues" class="p-col-12 p-md-4">
								<p-radioButton
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.manipulacionCarga.value}"
									[value]="item.value" formControlName="manipulacionCarga" [label]="item.label"
									name="manipulacionCarga" [ngModel]="examen.manipulacionCarga"
									[disabled]="examen?.modoVista === 'ver'"
									(onClick)="clickRadioButtonManipulacionCarga()">
								</p-radioButton>
							</div>
						</div>
						<app-invalid-from-message *ngIf="submitted && !f.manipulacionCarga.value">
						</app-invalid-from-message>
					</div>
				</div>
			</div>

			<!-- ---------------------------------- 6. Evaluación Clínica ---------------------------------- -->
			<div *ngIf="configForm.findSection('EvaluacionClinica')">
				<div class="print_dont_break">
					<div class="p-grid p-mt-2">
						<span class="p-title-seccion">
							{{ configForm.findNumberSection("EvaluacionClinica") }}. Evaluación Clínica
						</span>
					</div>
					<p-divider></p-divider>
					<div class="p-field-without-border p-col-12 p-md-12 print_row-full print_row-fill-block">
						<div class="p-grid print_row-content-inline">
							<div class="p-col-12 p-md-12">
								<app-fiel-title label="Curvas fisiológicas: eje anterposterior: " required="true">
								</app-fiel-title>
							</div>
							<div *ngFor="let item of curvasValues" class="p-col-12 p-md-4">
								<p-radioButton
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.curFisEjeAnterposterior.value}"
									[value]="item.value" formControlName="curFisEjeAnterposterior" [label]="item.label"
									name="curFisEjeAnterposterior" [ngModel]="examen.curFisEjeAnterposterior"
									[disabled]="examen?.modoVista === 'ver'">
								</p-radioButton>
							</div>
						</div>
						<app-invalid-from-message *ngIf="submitted && !f.curFisEjeAnterposterior.value">
						</app-invalid-from-message>
					</div>
				</div>
				<div class="p-field-without-border p-col-12 p-md-12 print_row-full print_row-fill-block print_dont_break">
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Desviaciones del eje lateral: " required="true"></app-fiel-title>
						</div>
						<div *ngFor="let item of ejeLateralValues" class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.desEjeLateral.value}"
								[value]="item.value" formControlName="desEjeLateral" [label]="item.label"
								name="desEjeLateral" [ngModel]="examen.desEjeLateral"
								[disabled]="examen?.modoVista === 'ver'">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && !f.desEjeLateral.value">
					</app-invalid-from-message>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<app-fiel-title label="Palpación:" required="true"></app-fiel-title>
					<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
						<div class="p-field-checkbox">
							<p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && !f.palpacionNormal.value && !f.palpacionApofosisEspinosa.value 
								&& !f.palpacionContracturaMuscular.value}" formControlName="palpacionNormal" inputId="palpacionNormal" 
								label="Normal" name="palpacionNormal" [disabled]="examen?.modoVista === 'ver'" (onChange)="clickCheckBoxPalpacion('NORMAL')">
							</p-checkbox>
						</div>
						<div class="p-field-checkbox">
							<p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && !f.palpacionNormal.value && !f.palpacionApofosisEspinosa.value 
								&& !f.palpacionContracturaMuscular.value}" formControlName="palpacionApofosisEspinosa" inputId="palpacionApofosisEspinosa" 
								label="Apófisis espinosas dolorosas" name="palpacionApofosisEspinosa" (onChange)="clickCheckBoxPalpacion('ESPINOSA')"
								[ngModel]="examen.palpacionApofosisEspinosa === true" [disabled]="examen?.modoVista === 'ver'">
							</p-checkbox>
						</div>
						<div class="p-field-checkbox">
							<p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && !f.palpacionNormal.value && !f.palpacionApofosisEspinosa.value 
								&& !f.palpacionContracturaMuscular.value}" formControlName="palpacionContracturaMuscular" inputId="palpacionContracturaMuscular" 
								label="Contractura muscular" name="palpacionContracturaMuscular" (onChange)="clickCheckBoxPalpacion('MUSCULAR')"
								[ngModel]="examen.palpacionContracturaMuscular === true" [disabled]="examen?.modoVista === 'ver'">
							</p-checkbox>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && !f.palpacionNormal.value
					  && !f.palpacionApofosisEspinosa.value && !f.palpacionContracturaMuscular.value"></app-invalid-from-message>
				</div>
				<div class="p-col-12 p-md-8 print_dont_break">
					<app-fiel-title label="Movilidad - Dolor: " required="true"></app-fiel-title>
					<div class="print_row-half" style="display: flex; white-space: nowrap;">
						<div class="p-md-3" style="padding: 0;">
							<div class="p-field-checkbox">
								<p-checkbox (onChange)="clickCheckBoxMovilidadDolor('movDolorNormal', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorNormal" inputId="movDolorNormal" label="Normal"
									name="movDolorNormal" [ngModel]="examen.movDolorNormal"
									[disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
							<div class="p-field-checkbox">
								<p-checkbox (onChange)="clickCheckBoxMovilidadDolor('movDolorFlexion', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorFlexion" inputId="movDolorFlexion" label="Flexión"
									name="movDolorFlexion" [ngModel]="examen.movDolorFlexion"
									[disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
						</div>
						<div class="p-md-3" style="padding: 0;">
							<div class="p-field-checkbox">
								<p-checkbox (onChange)="clickCheckBoxMovilidadDolor('movDolorExtension', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorExtension" inputId="movDolorExtension" label="Extensión"
									name="movDolorExtension" [ngModel]="examen.movDolorExtension"
									[disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
							<div class="p-field-checkbox">
								<p-checkbox
									(onChange)="clickCheckBoxMovilidadDolor('movDolorLateralizacionIzq', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorLateralizacionIzq" inputId="movDolorLateralizacionIzq"
									label="Lateralización Izq." name="movDolorLateralizacionIzq"
									[ngModel]="examen.movDolorLateralizacionIzq"
									[disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
						</div>
						<div class="p-md-3" style="padding: 0;">
							<div class="p-field-checkbox">
								<p-checkbox
									(onChange)="clickCheckBoxMovilidadDolor('movDolorLateralizacionDer', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorLateralizacionDer" inputId="movDolorLateralizacionDer"
									label="Lateralización Der." name="movDolorLateralizacionDer"
									[ngModel]="examen.movDolorLateralizacionDer"
									[disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
							<div class="p-field-checkbox">
								<p-checkbox (onChange)="clickCheckBoxMovilidadDolor('movDolorRotacionIzq', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorRotacionIzq" inputId="movDolorRotacionIzq"
									label="Rotación Izq." name="movDolorRotacionIzq"
									[ngModel]="examen.movDolorRotacionIzq" [disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
						</div>
						<div class="p-md-3" style="padding: 0;">
							<div class="p-field-checkbox">
								<p-checkbox (onChange)="clickCheckBoxMovilidadDolor('movDolorRotacionDer', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorRotacionDer" inputId="movDolorRotacionDer"
									label="Rotación Der." name="movDolorRotacionDer"
									[ngModel]="examen.movDolorRotacionDer" [disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
							<div class="p-field-checkbox">
								<p-checkbox (onChange)="clickCheckBoxMovilidadDolor('movDolorIrradiacion', $event)"
									binary="true"
									[ngClass]="{'ng-invalid ng-dirty': submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value}"
									formControlName="movDolorIrradiacion" inputId="movDolorIrradiacion"
									label="Irradiación." name="movDolorIrradiacion"
									[ngModel]="examen.movDolorIrradiacion" [disabled]="examen?.modoVista === 'ver'">
								</p-checkbox>
							</div>
						</div>
					</div>
					<app-invalid-from-message
						*ngIf="submitted && !f.movDolorNormal.value && !f.movDolorFlexion.value && !f.movDolorExtension.value && !f.movDolorLateralizacionIzq.value && !f.movDolorLateralizacionDer.value && !f.movDolorRotacionIzq.value && !f.movDolorRotacionDer.value && !f.movDolorIrradiacion.value">
					</app-invalid-from-message>
				</div>
				<div class="p-col-12 p-md-6 print_row-full print_dont_break">
					<app-fiel-title label="Describa: " [required]="f.movDolorIrradiacion.value"></app-fiel-title>
					<p [ngClass]="{'print_show-on-print': f.movDolorIrradiacionDescripcion.value.length > 0,
						  'print_hide-on-print': f.movDolorIrradiacionDescripcion.value.length < 1}"
						class="print_hidden-area-before-print print_row-full p-field-word-break">
						{{f.movDolorIrradiacionDescripcion.value}}
					</p>
					<textarea class="print_hide-on-print"
						[ngClass]="{'ng-invalid ng-dirty': submitted && f.movDolorIrradiacionDescripcion.invalid}"
						cols="30" formControlName="movDolorIrradiacionDescripcion" id="result" maxlength="1000"
						name="resul" pInputTextarea rows="5"
						[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
						</textarea>
					<small style="text-align: end;">
						{{ f.movDolorIrradiacionDescripcion.value.length }}/1000
					</small>
					<app-invalid-from-message *ngIf="submitted && f.movDolorIrradiacionDescripcion.errors?.required">
					</app-invalid-from-message>
					<app-invalid-from-message *ngIf="f.movDolorIrradiacionDescripcion.errors?.maxlength"
						message="Solo se permiten {{ f.movDolorIrradiacionDescripcion.errors.maxlength.requiredLength  }} caracteres">
					</app-invalid-from-message>
				</div>
				<div class="p-col-12 p-md-6 print_dont_break">
					<app-fiel-title label="Exploración Neurológica: " [required]="true"></app-fiel-title>
					<table class="p-datatable-solid enabled">
						<thead>
							<tr>
								<th class="no-border-cell"></th>
								<th class="no-border-cell"></th>
								<th>Positivo</th>
								<th>Negativo</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="2">Lasegue</td>
								<td>Derecha</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('lasegueDerechoP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="lasegueDerechoP" inputId="lasegueDerechoP" label=""
										name="lasegueDerechoP" [ngModel]="examen.lasegueDerechoP"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('lasegueDerechoN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="lasegueDerechoN" inputId="lasegueDerechoN" label=""
										name="lasegueDerechoN" [ngModel]="examen.lasegueDerechoN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td>Izquierda</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('lasegueIzquierdoP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="lasegueIzquierdoP" inputId="lasegueIzquierdoP" label=""
										name="lasegueIzquierdoP" [ngModel]="examen.lasegueIzquierdoP"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('lasegueIzquierdoN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="lasegueIzquierdoN" inputId="lasegueIzquierdoN" label=""
										name="lasegueIzquierdoN" [ngModel]="examen.lasegueIzquierdoN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td rowspan="2">Bragard</td>
								<td>Derecha</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('bragardDerechoP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="bragardDerechoP" inputId="bragardDerechoP" label=""
										name="bragardDerechoP" [ngModel]="examen.bragardDerechoP"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('bragardDerechoN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="bragardDerechoN" inputId="bragardDerechoN" label=""
										name="bragardDerechoN" [ngModel]="examen.bragardDerechoN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td>Izquierda</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('bragardIzquierdoP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="bragardIzquierdoP" inputId="bragardIzquierdoP" label=""
										name="bragardIzquierdoP" [ngModel]="examen.bragardIzquierdoP"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('bragardIzquierdoN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="bragardIzquierdoN" inputId="bragardIzquierdoN" label=""
										name="bragardIzquierdoN" [ngModel]="examen.bragardIzquierdoN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td rowspan="2">Dorsiflexión 1° Dedo de pie (Hallux)</td>
								<td>Derecha</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('halluxDerechoP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="halluxDerechoP" inputId="halluxDerechoP" label=""
										name="halluxDerechoP" [ngModel]="examen.halluxDerechoP"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('halluxDerechoN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="halluxDerechoN" inputId="halluxDerechoN" label=""
										name="halluxDerechoN" [ngModel]="examen.halluxDerechoN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td>Izquierda</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('halluxIzquierdoP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="halluxIzquierdoP" inputId="halluxIzquierdoP" label=""
										name="halluxIzquierdoP" [ngModel]="examen.halluxIzquierdoP"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('halluxIzquierdoN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="halluxIzquierdoN" inputId="halluxIzquierdoN" label=""
										name="halluxIzquierdoN" [ngModel]="examen.halluxIzquierdoN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td>Valsalva</td>
								<td></td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('valsalvaP', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="valsalvaP" inputId="valsalvaP" label="" name="valsalvaP"
										[ngModel]="examen.valsalvaP" [disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionNeurologica"
										(onChange)="clickTableExploracionNeurologica('valsalvaN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionNeurologicaInvalid}"
										formControlName="valsalvaN" inputId="valsalvaN" label="" name="valsalvaN"
										[ngModel]="examen.valsalvaN" [disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
						</tbody>
					</table>
					<app-invalid-from-message *ngIf="submitted && tableExploracionNeurologicaInvalid">
					</app-invalid-from-message>
				</div>
				<div class="p-col-12 p-md-6 print_dont_break">
					<app-fiel-title label="Exploración Reflejos: " [required]="true"></app-fiel-title>
					<table class="p-datatable-solid enabled">
						<thead>
							<tr>
								<th class="no-border-cell"></th>
								<th class="no-border-cell"></th>
								<th>Hiporreflexia</th>
								<th>Arreflexia</th>
								<th>Normal</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="2">Patelar</td>
								<td>Derecha</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('patelarDerechaH', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="patelarDerechaH" inputId="patelarDerechaH" label=""
										name="patelarDerechaH" [ngModel]="examen.patelarDerechaH"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('patelarDerechaA', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="patelarDerechaA" inputId="patelarDerechaA" label=""
										name="patelarDerechaA" [ngModel]="examen.patelarDerechaA"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('patelarDerechaN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="patelarDerechaN" inputId="patelarDerechaN" label=""
										name="patelarDerechaN" [ngModel]="examen.patelarDerechaN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td>Izquierda</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('patelarIzquierdaH', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="patelarIzquierdaH" inputId="patelarIzquierdaH" label=""
										name="patelarIzquierdaH" [ngModel]="examen.patelarIzquierdaH"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('patelarIzquierdaA', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="patelarIzquierdaA" inputId="patelarIzquierdaA" label=""
										name="patelarIzquierdaA" [ngModel]="examen.patelarIzquierdaA"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('patelarIzquierdaN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="patelarIzquierdaN" inputId="patelarIzquierdaN" label=""
										name="patelarIzquierdaN" [ngModel]="examen.patelarIzquierdaN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td rowspan="2">Aquiliano</td>
								<td>Derecha</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('aquilianorDerechaH', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="aquilianorDerechaH" inputId="aquilianorDerechaH" label=""
										name="aquilianorDerechaH" [ngModel]="examen.aquilianorDerechaH"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('aquilianorDerechaA', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="aquilianorDerechaA" inputId="aquilianorDerechaA" label=""
										name="aquilianorDerechaA" [ngModel]="examen.aquilianorDerechaA"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('aquilianorDerechaN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="aquilianorDerechaN" inputId="aquilianorDerechaN" label=""
										name="aquilianorDerechaN" [ngModel]="examen.aquilianorDerechaN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
							<tr>
								<td>Izquierda</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('aquilianorIzquierdaH', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="aquilianorIzquierdaH" inputId="aquilianorIzquierdaH" label=""
										name="aquilianorIzquierdaH" [ngModel]="examen.aquilianorIzquierdaH"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('aquilianorIzquierdaA', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="aquilianorIzquierdaA" inputId="aquilianorIzquierdaA" label=""
										name="aquilianorIzquierdaA" [ngModel]="examen.aquilianorIzquierdaA"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
								<td>
									<p-checkbox class="tableExploracionReflejos"
										(onChange)="clickTableExploracionReflejos('aquilianorIzquierdaN', $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableExploracionReflejosInvalid}"
										formControlName="aquilianorIzquierdaN" inputId="aquilianorIzquierdaN" label=""
										name="aquilianorIzquierdaN" [ngModel]="examen.aquilianorIzquierdaN"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</td>
							</tr>
						</tbody>
					</table>
					<app-invalid-from-message *ngIf="submitted && tableExploracionReflejosInvalid">
					</app-invalid-from-message>
				</div>
				<div class="p-col-12 p-md-6 print_dont_break">
					<app-fiel-title label="Evaluación Clínica Final: " [required]="true"></app-fiel-title>
					<table class="p-datatable-solid enabled">
						<tbody>
							<tr *ngFor="let item of gradosValues">
								<td>{{ item.label }}</td>
								<td>
									<p-checkbox class="tableEvaluacionClinicaFinal"
										(onChange)="clickTableEvaluacionClinicaFinal(item.value, $event.checked)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && tableEvaluacionClinicaFinalInvalid}"
										[formControlName]="item.value" inputId="evaluacionClinicaFinal"
										name="evaluacionClinicaFinal" [ngModel]="examen[item.value]"
										[readonly]="examen?.modoVista === 'ver'|| disabledGroup"
										[ngStyle]="disabledGroup ? disabledStyle : {}">
									</p-checkbox>
								</td>
								<td>{{ item.descripcion }}</td>
							</tr>
						</tbody>
					</table>
					<app-invalid-from-message *ngIf="submitted && tableEvaluacionClinicaFinalInvalid">
					</app-invalid-from-message>
				</div>
			</div>

			<!-- ---------------------------------- 7. Observaciones ---------------------------------- -->
			<div *ngIf="configForm.findSection('Observaciones')">
				<div class="print_dont_break">
					<div class="p-grid p-mt-2">
						<span class="p-title-seccion">
							{{ configForm.findNumberSection("Observaciones") }}. Observaciones
						</span>
					</div>
					<p-divider></p-divider>
					<div class="p-col-12 p-md-12">
						<div class="p-grid">
							<div class="p-col-12 p-md-12">
								<app-fiel-title label="Observaciones: " required="true">
								</app-fiel-title>
							</div>
							<div class="p-col-12 p-md-6 print_row-full">
								<p [ngClass]="{'print_show-on-print': f.observaciones.value.length > 0,
                              		'print_hide-on-print': f.observaciones.value.length < 1}"
									class="print_hidden-area-before-print print_row-full p-field-word-break">
									{{f.observaciones.value}}
								</p>
								<textarea class="print_hide-on-print"
									[ngClass]="{'ng-invalid ng-dirty': submitted && f.observaciones.invalid}" cols="30"
									formControlName="observaciones" id="result" maxlength="1000" name="resul"
									pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
                				</textarea>
								<small style="text-align: end;">
									{{ f.observaciones.value.length }}/1000
								</small>
								<app-invalid-from-message *ngIf="submitted && f.observaciones.errors?.required">
								</app-invalid-from-message>
								<app-invalid-from-message *ngIf="f.observaciones.errors?.maxlength"
									message="Solo se permiten {{ f.observaciones.errors.maxlength.requiredLength  }} caracteres">
								</app-invalid-from-message>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--Seccion Dictamen medico-->
			<div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Dictamen medico") }}. Dictamen médico
				</label>
				<p-divider></p-divider>

				<div class="p-grid">
					<!--Campo Tipo Dictamen-->
					<div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

							<div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

								<p-radioButton name="codigoDictamen" [value]="item.codigo"
									formControlName="codigoDictamen" label="{{ item.descripcion }}"
									[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
									[disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
								</p-radioButton>

							</div>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid">
						</app-invalid-from-message>
					</div>

					<!--Campo Especialidades-->
					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Especialidad" required="true"></app-fiel-title>
						<p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
							[options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
							optionLabel="descripcion" optionValue="codigo" [showClear]="true"
							[disabled]="examen?.modoVista === 'ver'">
						</p-dropdown>
						<app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid">
						</app-invalid-from-message>
					</div>

					<!--Campo Médico-->
					<div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Médico" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}"
							alfanumericoDirective formControlName="medicoNombre" id="medico" name="medico"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid">
						</app-invalid-from-message>
					</div>

					<!--Campo Matricula-->
					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Matrícula" required="true"></app-fiel-title>
						<!-- Modificar para validar el formato de la matricula -->
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoMatricula.invalid}"
							numberDirective formControlName="medicoMatricula" id="medicoMatricula"
							name="medicoMatricula" maxlength="18" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoMatricula.invalid">
						</app-invalid-from-message>
					</div>
				</div>
				<div class="p-grid p-form-footer">
					<div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
						<button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button"
							label="Firmar" (click)="showModalFirma()"></button>
					</div>
					<div class="p-field p-col-12 p-md-12">
						<app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
					</div>
				</div>
			</div>

			<!-- ------------ ADJUNTAR ARCHIVO ------------ -->
			<div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Adjuntos") }}. Archivos adjuntos
					<strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
					<span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
						{{ attachedFiles.attachedFilesValidQuantity }}
					</span>
				</label>
				<p-divider></p-divider>

				<app-attach-upload-file [examenNumero]="this.examen?.id" [isRequire]="configForm.isAttachedFileRequire"
					(filesAttachedData)="getAttachedFiles($event)" [attachedFilesFromBackend]="this.examen?.attachments"
					[viewMode]="this.examen?.modoVista" [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
				</app-attach-upload-file>

				<app-attached-file-mandatory-message
					*ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
				</app-attached-file-mandatory-message>
			</div>
			<!-- ------------------------------------------------footer botones------------------------------------------------ -->
			<div class="p-grid p-form-footer">
				<div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
					<ng-container *ngIf="examen?.modoVista === 'ver'">
						<button pButton pRipple type="button" label="Volver" class="p-button-text"
							(click)="goBack()"></button>
					</ng-container>

					<ng-container *ngIf="examen?.modoVista !== 'ver'">
						<button pButton pRipple type="button" label="Cancelar" class="p-button-text"
							(click)="goBack()"></button>
						<p-button type="submit" label="Guardar" *ngIf="!enviandose"
							[disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
						</p-button>
						<p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
					</ng-container>
				</div>
			</div>

			<app-print-footer [firmaB64]="examen?.firmaB64" [medicoFirmaB64]="medicoFirmaB64"
				[trabajadorApellidoNombre]="f.apellidoNombre.value" [medicoNombre]="f.medicoNombre?.value"
				[medicoEspecialidad]="f.medicoEspecialidad.value" [medicoMatricula]="f.medicoMatricula?.value">
			</app-print-footer>

		</div>
	</form>

	<p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormG"
		styleClass="p-dialog-custom">
		<p-footer>
			<button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton
				type="button"></button>
			<button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
		</p-footer>

	</p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma"
		(closeModal)="closeModalFirma()"></app-topaz>
</section>